import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Popup } from 'react-leaflet';
import { isPivot } from 'common/utils/helpers';
import { IconLoader } from 'common/IconLoader';
import { isGa2Device } from 'common/utils/deviceTwinUtils';
import { PerfectScrollbar } from '../../../../../shared/ReactPerfectScrollbar';
import SearchBar from '../../../../../shared/SearchBar/SearchBar';
import DeviceTable from '../../../DeviceTable/DeviceTable';
import styles from './DeviceGroupPopup.module.css';

const OFFSET = [0, -23];
const TOP_LEFT_PADDING = [80, 80];
const BOTTOM_RIGHT_PADDING = [80, 80];

function DeviceGroupPopup({ position, devices, bulkViewModalOpen, onClose }) {
  const [search, setSearch] = useState('');
  const filteredDevices = useMemo(
    () => devices.filter((device) => device.deviceId.includes(search)),
    [devices, search]
  );

  return (
    <Popup
      position={position}
      offset={OFFSET}
      minWidth={bulkViewModalOpen ? 292 : 228}
      maxWidth={292}
      minHeight={180}
      maxHeight={292}
      autoPan={true}
      autoPanPaddingTopLeft={TOP_LEFT_PADDING}
      autoPanPaddingBottomRight={BOTTOM_RIGHT_PADDING}
      onClose={onClose}
    >
      <div className={styles.container}>
        <div className={styles.search}>
          <div className={styles.control}>
            <SearchBar searchQuery={setSearch} defaultText="Search Device" />
          </div>
        </div>
        {bulkViewModalOpen ? (
          <DeviceTable devices={filteredDevices} hasCheckbox={false} forAlarmMap={true} />
        ) : (
          <PerfectScrollbar options={{ wheelPropagation: false }}>
            <ul className={styles.list}>
              {filteredDevices.map((device) => {
                const pivot = isPivot(device);
                const isGa2 = isGa2Device(device);
                const url = isGa2
                  ? `/console/devices/pivot/overview?deviceId=${device.deviceId}`
                  : `/console/devices/detail?${device.deviceId}`;

                return (
                  <li key={device.deviceId} className={styles.item}>
                    <Link to={url}>
                      <img alt={pivot ? 'pivot' : 'echo'} src={pivot ? IconLoader.icon_pivot : IconLoader.icon_echo} />
                      {device.deviceId}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </PerfectScrollbar>
        )}
      </div>
    </Popup>
  );
}

export default DeviceGroupPopup;
